export const setWalkthroughStepDone = (step) => {
    const key = `walkthrough_step_${step}_done`;
    localStorage.setItem(key, 'true');
};

export const isWalkthroughStepDone = (step) => {
    const key = `walkthrough_step_${step}_done`;
    return localStorage.getItem(key) === 'true';
};

export const resetWalkthroughSteps = () => {
    localStorage.removeItem('walkthrough_step_1_done');
    localStorage.removeItem('walkthrough_step_2_done');
    localStorage.removeItem('walkthrough_step_3_done');
    localStorage.removeItem('walkthrough_step_4_done');
    localStorage.removeItem('walkthrough_step_5_done');
    localStorage.setItem("isOnboardingWalkthroughRequired", "true");
    localStorage.setItem("onboardingWalkthroughCompleted", "false");
    localStorage.setItem("onboardingWalkthroughStep", "0");
    localStorage.setItem("onboardingWalkthroughSkipped", "false");
    localStorage.setItem('scheduleEventCompletedByUser', 'false');
    localStorage.removeItem('onboardingWalkthroughCompletedAt');
    localStorage.removeItem('shopifyPoWalkthroughCompleted');
    localStorage.removeItem('aiBfcmPlannerCoachSeen');
    sessionStorage.removeItem('aiBfcmPlannerCoachSeen');
};

// Records the timestamp when the main onboarding walkthrough finishes (first call only).
export const setOnboardingWalkthroughCompletedAt = () => {
    if (!localStorage.getItem('onboardingWalkthroughCompletedAt')) {
        localStorage.setItem('onboardingWalkthroughCompletedAt', String(Date.now()));
    }
};

export const isShopifyPoWalkthroughCompleted = () => {
    return localStorage.getItem('shopifyPoWalkthroughCompleted') === 'true';
};

export const setShopifyPoWalkthroughCompleted = () => {
    localStorage.setItem('shopifyPoWalkthroughCompleted', 'true');
};

/*
 * AI BFCM Planner Joyride — hidden for the rest of this browser session
 * after Got it / Watch Demo. A new session shows it again while the shop
 * still has no chatbot threads.
 *
 * Example: isAiBfcmPlannerCoachCompleted() → true after Got it in this tab,
 *          false after the tab session ends.
 */
export const isAiBfcmPlannerCoachCompleted = () => {
    /*
     * Older builds saved this forever in localStorage, which blocked the
     * highlight from returning next session. Drop that leftover.
     */
    localStorage.removeItem('aiBfcmPlannerCoachSeen');
    return sessionStorage.getItem('aiBfcmPlannerCoachSeen') === '1';
};

export const setAiBfcmPlannerCoachCompleted = () => {
    sessionStorage.setItem('aiBfcmPlannerCoachSeen', '1');
};

export const clearAiBfcmPlannerCoachCompleted = () => {
    sessionStorage.removeItem('aiBfcmPlannerCoachSeen');
    localStorage.removeItem('aiBfcmPlannerCoachSeen');
};

// Email recipients page redirect flag management
const SHOULD_REDIRECT_USER_TO_EMAIL_RECIPIENTS_PAGE_FLAG_KEY = 'shouldRedirectUserToEmailRecipientsPageFlag';

export const setShouldRedirectUserToEmailRecipientsPageFlag = (value) => {
    localStorage.setItem(SHOULD_REDIRECT_USER_TO_EMAIL_RECIPIENTS_PAGE_FLAG_KEY, value.toString());
};

export const getShouldRedirectUserToEmailRecipientsPageFlag = () => {
    return localStorage.getItem(SHOULD_REDIRECT_USER_TO_EMAIL_RECIPIENTS_PAGE_FLAG_KEY) === 'true';
};

export const clearShouldRedirectUserToEmailRecipientsPageFlag = () => {
    localStorage.removeItem(SHOULD_REDIRECT_USER_TO_EMAIL_RECIPIENTS_PAGE_FLAG_KEY);
};

// Desired settings tab (goto) management for redirects
const DESIRED_SETTINGS_GOTO_TAB_KEY = 'desiredSettingsGotoTab';

export const setDesiredSettingsGotoTab = (gotoValue) => {
    if (gotoValue === undefined || gotoValue === null) return;
    localStorage.setItem(DESIRED_SETTINGS_GOTO_TAB_KEY, String(gotoValue));
};

export const getDesiredSettingsGotoTab = () => {
    return localStorage.getItem(DESIRED_SETTINGS_GOTO_TAB_KEY);
};

export const clearDesiredSettingsGotoTab = () => {
    localStorage.removeItem(DESIRED_SETTINGS_GOTO_TAB_KEY);
};

// Onboarding walkthrough completion flag
export const isOnboardingWalkthroughCompleted = () => {
  return localStorage.getItem("onboardingWalkthroughCompleted") === "true";
};

// Post-OAuth return URL — saved before any scope-grant redirect so Auth.jsx
// can send the user back to wherever they came from instead of email setup.
const POST_AUTH_RETURN_URL_KEY = "postAuthReturnUrl";

export const setPostAuthReturnUrl = (url) => {
  localStorage.setItem(POST_AUTH_RETURN_URL_KEY, url);
};

export const getPostAuthReturnUrl = () => {
  return localStorage.getItem(POST_AUTH_RETURN_URL_KEY);
};

export const clearPostAuthReturnUrl = () => {
  localStorage.removeItem(POST_AUTH_RETURN_URL_KEY);
};

// Inventory Transfer Scopes grant prompt cooldown (1-week snooze)
const INVENTORY_TRANSFER_SCOPES_PROMPT_SNOOZED_AT_KEY = 'inventoryTransferScopesPromptSnoozedAt';
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export const setInventoryTransferScopesPromptSnoozedAt = () => {
  localStorage.setItem(INVENTORY_TRANSFER_SCOPES_PROMPT_SNOOZED_AT_KEY, String(Date.now()));
};

export const clearInventoryTransferScopesPromptSnoozedAt = () => {
  localStorage.removeItem(INVENTORY_TRANSFER_SCOPES_PROMPT_SNOOZED_AT_KEY);
};

export const isInventoryTransferScopesPromptSnoozed = () => {
  const snoozedAt = localStorage.getItem(INVENTORY_TRANSFER_SCOPES_PROMPT_SNOOZED_AT_KEY);
  if (!snoozedAt) return false;
  return Date.now() - Number(snoozedAt) < ONE_WEEK_MS;
};

/*
 * Incoming Inventory banner that teaches merchants how to add the
 * IFH Display Arrival Dates theme app block. Once dismissed, stay hidden.
 * Example: isDisplayArrivalDatesBannerDismissed() → true after they click X
 */
const DISPLAY_ARRIVAL_DATES_BANNER_DISMISSED_KEY = "displayArrivalDatesBannerDismissed";

export const isDisplayArrivalDatesBannerDismissed = () => {
  return localStorage.getItem(DISPLAY_ARRIVAL_DATES_BANNER_DISMISSED_KEY) === "true";
};

export const setDisplayArrivalDatesBannerDismissed = () => {
  localStorage.setItem(DISPLAY_ARRIVAL_DATES_BANNER_DISMISSED_KEY, "true");
};
